import { Grid } from '@mui/material'
import { AppBox, AppTypography, AppButton, AppCheckBox, AppTextArea } from 'components'
import { FC, useEffect } from 'react'
import { AppSelect } from 'components/base/select/AppSelect'
import { useForm } from 'react-hook-form'
import { useMembershipHelper } from 'hooks'
import { getMDYFormattedDate } from 'globals/functions'

interface Props {
  isFormFilled: (val: boolean) => void
  onReasonChange: (val: string) => void
  onCommentsChange: (val: string) => void
}

export const CancelMembershipVerification: FC<Props> = ({ isFormFilled, onCommentsChange, onReasonChange }) => {
  const { CurrentMembership } = useMembershipHelper()
  const {
    control,
    watch,
    formState: { isValid },
  } = useForm<{
    duration: string
    comments: string
    cancelTimeAgreed: boolean
    usercancelAgreed: boolean
  }>()

  const reasonOptions = [
    {
      label: 'Don’t use it enough',
      value: 'Don’t use it enough',
    },
    {
      label: 'It’s too expensive',
      value: 'It’s too expensive',
    },
    {
      label: 'Has too many bugs',
      value: 'Has too many bugs',
    },
    {
      label: 'I’m leaving the industry',
      value: 'I’m leaving the industry',
    },
    {
      label: 'I don’t understand it',
      value: 'I don’t understand it',
    },
    {
      label: 'I found something better',
      value: 'I found something better',
    },
  ]
  useEffect(() => {
    isFormFilled(isValid)
  }, [watch()])
  return (
    <AppBox>
      <AppTypography fontSize={32} fontWeight={700} textAlign={'center'}>
        Help us improve
      </AppTypography>
      <AppBox paddingX={2} paddingTop={2}>
        <AppTypography fontSize={16} fontWeight={'bold'}>
          Reason of Cancelling
        </AppTypography>
        <AppTypography color={'grey.500'} fontSize={14}>
          Before we cancel your subscription plan, please select the reason for your cancellation. Please add any
          additional comments you think may help us improve our site.
        </AppTypography>
        <Grid item xs={6} paddingY={2}>
          <AppSelect
            control={control}
            name="duration"
            options={reasonOptions}
            label="Reason"
            placeholder="Select Reason"
            required={true}
            onFieldChange={(e) => onReasonChange(e.target.value)}
          />
        </Grid>
        <AppTextArea
          control={control}
          name="comments"
          placeholder="Please provide any additional comments"
          onFieldChange={(e) => onCommentsChange(e.target.value)}
        />
        <AppCheckBox
          required
          control={control}
          name="cancelTimeAgreed"
          label={
            'Cancel my subscription plan when my current billing cycle ends on ' +
            getMDYFormattedDate(new Date(CurrentMembership()?.CurrentPeriodEnd ?? ''))
          }
        />
        <AppCheckBox
          required
          control={control}
          name="usercancelAgreed"
          label="I understand that canceling my subscription plan will also cancel all of my plan’s users."
        />
      </AppBox>
    </AppBox>
  )
}
